(function () {
  function initSlider(root) {
    if (!root || root.dataset.tpsReady === 'true') return;
    root.dataset.tpsReady = 'true';
    const track = root.querySelector('[data-tps-review-track]');
    const prev = root.querySelector('[data-tps-prev]');
    const next = root.querySelector('[data-tps-next]');
    const dotsWrap = root.querySelector('[data-tps-dots]');
    if (!track) return;
    const cards = () => Array.from(track.children);
    const step = () => (cards()[0]?.getBoundingClientRect().width || 280) + 14;
    const pages = () => Math.max(1, Math.ceil(track.scrollWidth / track.clientWidth));
    let dots = [];
    function updateDots() {
      if (!dots.length) return;
      const idx = Math.min(dots.length - 1, Math.round(track.scrollLeft / Math.max(track.clientWidth, 1)));
      dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
    }
    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      dots = Array.from({ length: pages() }, (_, i) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', `Go to review group ${i + 1}`);
        b.addEventListener('click', () => track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }));
        dotsWrap.appendChild(b);
        return b;
      });
      updateDots();
    }
    prev?.addEventListener('click', () => track.scrollBy({ left: -Math.max(track.clientWidth * .85, step()), behavior: 'smooth' }));
    next?.addEventListener('click', () => track.scrollBy({ left: Math.max(track.clientWidth * .85, step()), behavior: 'smooth' }));
    track.addEventListener('scroll', updateDots, { passive: true });
    window.addEventListener('resize', buildDots);
    buildDots();
  }

  function initStickyCta(root) {
    if (!root || root.dataset.tpsStickyReady === 'true') return;
    root.dataset.tpsStickyReady = 'true';
    const sticky = root.querySelector('[data-tps-sticky]');
    if (!sticky) return;

    const threshold = Math.max(0, Math.min(90, parseFloat(sticky.dataset.scrollPercent || '40')));

    function updateSticky() {
      if (!window.matchMedia('(max-width: 749px)').matches) {
        sticky.classList.remove('is-visible');
        return;
      }
      const doc = document.documentElement;
      const maxScroll = Math.max(1, doc.scrollHeight - window.innerHeight);
      const percent = (window.scrollY / maxScroll) * 100;
      sticky.classList.toggle('is-visible', percent >= threshold);
    }

    window.addEventListener('scroll', updateSticky, { passive: true });
    window.addEventListener('resize', updateSticky);
    updateSticky();
  }

  function boot() {
    document.querySelectorAll('[data-tps-review-slider]').forEach(initSlider);
    document.querySelectorAll('[data-tps-presale-root]').forEach(initStickyCta);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
